import { apiFetch } from './api';
import type { Device, Category, VendorPrice } from '../types/models';

export async function searchDevices(query: string, category?: Category): Promise<Device[]> {
  const res = await apiFetch<{ devices: Device[] }>('/devices', {
    params: { q: query, category },
  });
  return res.devices;
}

export async function getDevice(id: string): Promise<Device> {
  const res = await apiFetch<{ device: Device }>(`/devices/${id}`);
  return res.device;
}

export async function getDevicePrices(deviceId: string): Promise<VendorPrice[]> {
  const res = await apiFetch<{ prices: VendorPrice[] }>(`/devices/${deviceId}/prices`);
  return res.prices;
}
